export default __webpack_public_path__ + "static/media/arrowBack.78ef33f3.svg";